<template>
  <a-modal
    title="操作"
    style="top: 20px;"
    :width="800"
    v-model="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
  >
    <a-form :form="form">
      <a-form-item style="display:none">
        <a-input v-decorator="['userId']" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户名">
        <a-input v-decorator="['loginName', { rules: [{ required: true, message: '请输入用户名' }] }]" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="密码" v-if="isAdd === true">
        <a-input v-decorator="['password', { rules: [{ validator: this.isPwd, required: true }] }]" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="客服名">
        <a-input v-decorator="['userName', { rules: [{ required: true, message: '请输入客服名' }] }]" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名">
        <a-input v-decorator="['realName', { rules: [{ required: true, message: '请输入姓名' }] }]" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号">
        <a-input v-decorator="['phone', { rules: [{ validator: this.isPhone, required: true }] }]" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备用联系方式">
        <a-input v-decorator="['contactReserve']" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="性别">
        <a-select v-decorator="['sex', { initialValue: '0' }]">
          <a-select-option :value="'0'">男</a-select-option>
          <a-select-option :value="'1'">女</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地址">
        <a-select
          style="width:33%;margin-right: 10px"
          :allowClear="true"
          :options="provinceMap"
          @change="changeProvince"
          v-decorator="['provinceId']"
        ></a-select>
        <a-select
          style="width:30%;margin-right: 10px"
          :allowClear="true"
          :options="cityMap"
          @change="changeCity"
          v-decorator="['cityId']"
        ></a-select>
        <a-select
          style="width:30%;margin-right: 10px"
          :allowClear="true"
          :options="areaArr"
          v-decorator="['districtId']"
        ></a-select>
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="详细地址">
        <a-input v-decorator="['detailedAddress']"></a-input>
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="紧急联系人">
        <a-input v-decorator="['emergencyContact']"></a-input>
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="紧急联系人电话">
        <a-input v-decorator="['linkmanPhonenumber']"></a-input>
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="入职时间">
        <a-date-picker v-decorator="['entryTime']" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
        <a-select v-decorator="['status', { initialValue: '0', rules: [{ required: true, message: '请选择状态' }] }]">
          <a-select-option :value="'0'">正常</a-select-option>
          <a-select-option :value="'1'">禁用</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门">
        <a-tree-select
          v-decorator="['deptId', { rules: [{ required: true, message: '请选择部门' }] }]"
          :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
          :treeData="deptTree"
          @change="onChange"
          treeDefaultExpandAll
        >
        </a-tree-select>
      </a-form-item>

      <!--      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="描述">-->
      <!--        <a-textarea :rows="5" v-decorator="['remark', {rules: [{ required: true, message: '请输入描述' }]}]"/>-->
      <!--      </a-form-item>-->

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="拥有角色" hasFeedback>
        <a-select
          style="width: 100%"
          mode="multiple"
          v-decorator="['roleIds', { rules: [{ required: true, message: '请选择角色' }] }]"
          :allowClear="true"
        >
          <a-select-option v-for="action in roleAll" :key="action.roleId">{{ action.roleName }}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { getRoleAll, editStaff, getEmployee, addStaff } from '@/api/system'
import { getselectAllProvince, getselectCityName, getselectAreaName } from '@/api/enterprise/enterprise'
import moment from 'moment'

export default {
  name: 'UserModal',
  props: {
    deptTree: {
      type: Array,
      required: true
    }
  },
  components: {},
  data() {
    return {
      isAdd: true,
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      roleAll: [],
      mdl: {},
      deptCheck: true,
      form: this.$form.createForm(this),
      provinceMap: [],
      cityMap: [],
      areaArr: []
    }
  },
  beforeCreate() {},
  async created() {
    this.loadRoleAll()
    // 省
    await getselectAllProvince().then(res => {
      if (res.code === 0) {
        res.rows.forEach(province => {
          this.provinceMap.push({ value: province.provinceCode, label: province.provinceName })
        })
      }
    })
  },
  methods: {
    // 密码正则表达式
    isPwd(rule, value, callback) {
      const pwdRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,64}$/
      if (value && !pwdRegex.test(value)) {
        callback(new Error('请输入8位以上密码，必须包含数字、字母、英文特殊字符'))
      } else if (value == undefined || value.length == 0) {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    },
    //手机号正则表达式
    isPhone(rule, value, callback) {
      const pwdRegex = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value && !pwdRegex.test(value)) {
        callback(new Error('请输入正确的11位电话号码'))
      } else if (value == undefined || value.length == 0) {
        callback(new Error('请输入电话号码'))
      } else {
        callback()
      }
    },
    add() {
      this.form.resetFields()
      this.isAdd = true
      this.visible = true
      this.form.setFieldsValue({ userId: '0' })
    },
    edit(record) {
      this.visible = true
      this.isAdd = false
      this.$nextTick(() => {
        getEmployee({ userId: record.userId }).then(res => {
          this.changeProvince(res.provinceId)
          this.changeCity(res.cityId)
          if (res.entryTime != null) {
            res.entryTime = moment(res.entryTime, 'YYYY-MM-DD')
          }

          this.form.setFieldsValue(res)
        })
      })
    },
    onChange(value, label, extra) {
      if (extra.triggerNode.$children.length > 0) {
        this.$message.error('不能选择父节点' + `${label}`)
        this.deptCheck = false
      } else {
        this.deptCheck = true
      }
    },
    loadRoleAll() {
      getRoleAll().then(res => {
        this.roleAll = res.rows
      })
    },
    changeProvince(e) {
      this.cityMap = []
      this.areaArr = []
      this.form.setFieldsValue({
        cityId: '',
        districtId: ''
      })
      // 市
      this.province = { provinceCode: e }
      getselectCityName(this.province).then(res => {
        if (res.code === 0) {
          res.rows.forEach(city => {
            this.cityMap.push({ value: city.cityCode, label: city.cityName })
          })
        }
      })
    },
    changeCity(e) {
      this.areaArr = []
      this.form.setFieldsValue({
        districtId: ''
      })
      // 区
      this.city = { cityCode: e }
      getselectAreaName(this.city).then(res => {
        if (res.code === 0) {
          res.rows.forEach(area => {
            this.areaArr.push({ value: area.areaCode, label: area.areaName })
          })
        }
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      if (!this.deptCheck) {
        this.$message.error('不能选择父节点')
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          this.confirmLoading = false
          // console.log(this.isAdd,'this.isAdd')
          if (values.entryTime == null) {
            // values.entryTime=null
          } else if (values['entryTime'] !== undefined && values['entryTime'] !== '') {
            values['entryTime'] = values['entryTime'].format('YYYY-MM-DD')
          }
          console.log(values)
          if (this.isAdd) {
            addStaff(values)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.$emit('ok')
                  this.visible = false
                } else {
                  this.$message.error(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            editStaff(values)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.$emit('ok')
                  this.visible = false
                } else {
                  this.$message.error(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
